import Vue from 'vue'
import Router from 'vue-router'

// 引入模块
import attendance from './attendance'
import common from './common'
import datascreen from './datascreen'
import dorm from './dorm'
import leave from './leave'
import flexleave from './flexleave'
import others from './others'
import system from './system'
import classcard from './classcard'
import afterschool from './afterschool'
import elective from './elective'
import classEvaluation from './classevaluation'
import schedule from './schedule'
import substitute from './substitute'
import recipes from './recipes'
import studentSign from './studentSign'
import moral from './moral'
import classrank from './classrank'
import familyCall from './familyCall'
import honour from './honour'
import welcome from './welcome'
import clearplate from './clearplate'
import message from './message'
import entryInformation from './entryInformation'
import vehicleManage from './vehicleManage'
import antibully from './antibully'
import security from './security'
import track from './track'
import behavior from './behavior'

import PageToken from '../pages/PageToken'
import PageHome from '../pages/PageHome'
import PageGuardianIndex from '../pages/PageGuardianIndex'

import PageWechatCode from '../pages/PageWechatCode'
import PageWechatIndex from '../pages/PageWechatIndex'
import PageWechatLoginAuth from '../pages/wechat/PageWechatLoginAuth'
import PageWechatGuideShare from '../pages/wechat/PageWechatGuideShare'
import PageWechatGuideIdList from '../pages/wechat/PageWechatGuideIdList'
import PageWechatEmpty from '../pages/wechat/PageWechatEmpty'
import PageWechatBind from '../pages/wechat/PageWechatBind'
import PageOrgAddressBook from '../pages/wechat/PageOrgAddressBook'
import PageSchoolCalendar from '../pages/system/PageSchoolCalendar'
import PageSchoolCalendarEdit from '../pages/system/PageSchoolCalendarEdit'
import faceInput from './faceInput'
import opendoor from './opendoor'
import meal from './meal'
import atschool from './atschool'
import face from './face'
import rights from './rights'
import { getRouteListPath } from '@/utils/comUtils'

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location, onComplete, onAbort) {
  if (typeof location === 'string') {
    location = {
      path: location,
      query: {}
    }
  }
  location = {
    ...location,
    query: {
      ...(location.query || {}),
      _rp: true
    }
  }
  originalReplace.call(this, location, onComplete, onAbort).catch(err => err)
}

//  解决触发导航守卫问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush
      .call(this, location, onResolve, onReject)
      .catch(err => err)
  }
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'PageToken',
    component: PageToken,
    meta: { modular: -1 }
  },
  {
    path: '/home',
    name: 'PageHome',
    component: PageHome,
    meta: {
      modular: -1,
      clearCachedViews: true,
      info: '首页——非家长',
      title: '魔点校园'
    }
  },
  {
    path: '/guardian',
    name: 'PageGuardianIndex',
    component: PageGuardianIndex,
    meta: {
      modular: -1,
      clearCachedViews: true,
      keepAlive: true,
      info: '首页——家长'
    }
  },

  /** todo 是否需要判断当前环境进行路由加载 */
  /** 微信公众号相关页面 */
  {
    path: '/wcode',
    name: 'PageWechatCode',
    component: PageWechatCode,
    alias: '/wcodetoken',
    meta: {
      modular: -1,
      info: '微信授权登录'
    }
  },
  {
    path: '/wechat',
    name: 'PageWechatIndex',
    component: PageWechatIndex,
    alias: '/wechattoken',
    meta: {
      modular: -1,
      info: '微信登录页面'
    }
  },
  {
    path: '/wechat/login',
    name: 'PageWechatLoginAuth',
    component: PageWechatLoginAuth,
    meta: {
      modular: -1,
      info: '微信登录授权页面'
    }
  },
  {
    path: '/wechat/guideshare',
    name: 'PageWechatGuideShare',
    component: PageWechatGuideShare,
    meta: {
      modular: -1,
      info: '家长信息管理'
    }
  },
  {
    path: '/wechat/guidesidlist',
    name: 'PageWechatGuideIdList',
    component: PageWechatGuideIdList,
    meta: {
      modular: -1,
      info: '家长信息管理'
    }
  },
  {
    path: '/wechat/empty',
    name: 'PageWechatEmpty',
    component: PageWechatEmpty,
    meta: {
      modular: -1,
      info: '家长信息管理'
    }
  },
  {
    path: '/wechat/bind',
    name: 'PageWechatBind',
    component: PageWechatBind,
    meta: {
      modular: -1,
      info: ''
    }
  },
  {
    path: '/org/addressBook',
    name: 'PageOrgAddressBook',
    component: PageOrgAddressBook,
    meta: {
      modular: -1,
      title: '机构通讯录',
      info: '机构通讯录'
    }
  },
  {
    path: '/schoolCalendar',
    name: 'PageSchoolCalendar',
    component: PageSchoolCalendar,
    meta: {
      modular: -1,
      title: '校历',
      info: '校历',
      keepAlive: true
    }
  },
  {
    path: '/schoolCalendar/edit',
    name: 'PageSchoolCalendarEdit',
    component: PageSchoolCalendarEdit,
    meta: {
      modular: -1,
      title: '校历',
      info: '校历'
    }
  },
  /** 微信公众号相关页面 */
  ...common,
  ...others,
  ...system,
  ...getRouteListPath([
    ...entryInformation,
    ...attendance,
    ...datascreen,
    ...dorm,
    ...leave,
    ...flexleave,
    ...classcard,
    ...afterschool,
    ...elective,
    ...classEvaluation,
    ...schedule,
    ...substitute,
    ...recipes,
    ...studentSign,
    ...moral,
    ...classrank,
    ...familyCall,
    ...honour,
    ...welcome,
    ...clearplate,
    ...message,
    ...vehicleManage,
    ...faceInput,
    ...antibully,
    ...security,
    ...track,
    ...opendoor,
    ...behavior,
    ...atschool,
    ...face,
    ...meal,
    ...rights
  ])
]
export default new Router({
  routes
})
